<template>
  <div class="overflow-auto max-w-[300px] min-w-[300px] shrink-0">
    <div v-if="userData" class="bg-primary flex-grow flex h-full">
      <accordion :active="active" :on-change="onAccordionChange" class="overflow-hidden w-full flex flex-col">
        <!--Project anlegen-->
        <SCProjekt></SCProjekt>
        <!--Neues Werbemittel-->
        <SCMagazine data-ui="create-magazine"></SCMagazine>
        <!--Projekte-->
        <SProjekts :accordion-index="active"></SProjekts>
        <!--Benutzer-->
        <SUser :accordion-index="active"></SUser>
        <!--Article stamm-->
        <SArticle :accordion-index="active"></SArticle>
        <!--Einkaufsbereich-->
        <SPurchaser :accordion-index="active"></SPurchaser>
        <!--Märkte-->
        <SMarket :accordion-index="active"></SMarket>
        <!--Formular-->
        <SFormular :accordion-index="active"></SFormular>
        <!--Product Feld-->
        <SProduktField :accordion-index="active"></SProduktField>
        <!--Regeln-->
        <SRule :accordion-index="active"></SRule>
        <!--Werbemittel Typen-->
        <SMagazineTyp :accordion-index="active"></SMagazineTyp>
        <!-- Template -->
        <STemplate :accordion-index="active"></STemplate>

        <SApi :accordion-index="active"></SApi>
        <!-- Super Admin Bereich -->
       <STable :accordion-index="active"></STable>
      </accordion>
    </div>
  </div>
</template>

<script>
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import Accordion from "@/components/Accordion/Accordion.vue";
import tabs from "@/components/Tabs/Tabs.vue";
import tab from "@/components/Tabs/Tab.vue";

import router from "@/router";
import {mapState} from "vuex";
import Spinner from "@/components/Base/Spinner.vue";
import TRInput from "@/components/Base/TRInput.vue";

import SUser from "@/components/Administration/User/SUser.vue";
import SApi from "@/components/Administration/Api/SApi.vue";
import STemplate from "@/components/Administration/Templates/STemplate.vue";
import SPurchaser from "@/components/Administration/Purchaser/SPurchaser.vue";
import SCProjekt from "@/components/Administration/Project/SCProjekt.vue";
import SProjekts from "@/components/Administration/Project/SProjekts.vue";
import SProduktField from "@/components/Administration/ProduktField/SProduktField.vue";
import SMarket from "@/components/Administration/Market/SMarket.vue";
import SCMagazine from "@/components/Administration/Magazine/SCMagazine.vue";
import SMagazineTyp from "@/components/Administration/Magazine/SMagazineTyp.vue";
import SFormular from "@/components/Administration/Formular/SFormular.vue";
import SArticle from "@/components/Administration/Artikel/SArticle.vue";
import SRule from "@/components/Administration/Rule/SRule.vue";
import STable from "@/components/Administration/SuperAdmin/STable.vue";
import {useRoute} from 'vue-router';

export default {
  components: {
    STable,
    SRule,

    TRInput,
    Spinner,
    Accordion,
    AccordionItem,
    tabs,
    tab,
    SUser,
    STemplate,
    SPurchaser,
    SCProjekt,
    SProjekts,
    SProduktField,
    SMarket,
    SCMagazine,
    SMagazineTyp,
    SFormular,
    SArticle,
    SApi
  },
  computed: {
    ...mapState('user', ['userData']),
  },
  data() {
    return {
      active: 0,
      fullRoute: "",
      route: "",
    };
  },
  methods: {
    onAccordionChange(index) {
      this.active = index;

      const newPath = this.route.replace(/\/administration\/\d+/, `/administration/${index}`);
      router.push(newPath);
    },
    getRoute() {
      let route = useRoute();
      this.fullRoute = route.fullPath;
      return this.fullRoute;
    },
    updateAccordion(newId) {
      this.active = parseInt(newId);
    },

  },
  created() {
    this.route = this.getRoute();
    this.updateAccordion(this.$route.params.accordionIndex);
  },
  mounted() {
    this.route = this.getRoute();
    this.updateAccordion(this.$route.params.accordionIndex);
  },
  watch: {},
};
</script>